"use strict";
import { applicationCountStateTransformer } from "./applicationCountStateTransformer";
import { applicationCountSourceTransformer } from "./applicationCountSourceTransformer";
import { applicationCountSourceTypeTransformer } from "./applicationCountSourceTypeTransformer";
export const transformer = (dataSource, shownAs, groupBy, data) => {
  if (groupBy === "state") {
    return applicationCountStateTransformer(data);
  } else if (groupBy === "source") {
    return applicationCountSourceTransformer(data);
  } else {
    return applicationCountSourceTypeTransformer(data);
  }
};
